/**
 * Ryan O'Dowd
 * 2024-10-28
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

// @NOTE: these are passed into Setup.js, so even though they aren't keyed into in ThemeProvider, they're needed here // @TODO: remove need for this?
const getStyles = ({colors, isDarkMode}) => {
  return {
    statusBarBackgroundColor: isDarkMode ? colors.primaryDark : colors.primary,
    setupContainer: {
      flex: 1,
      justifyContent: 'center',
      backgroundColor: isDarkMode ? colors.primaryExtraDark : colors.primary,
    },
    container: {
      flex: 1,
    },
    verse: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
  };
};

export default getStyles;
